import React, { useEffect, useState } from "react";

import type { Moment } from "moment-timezone";
import { useTranslation } from "react-i18next";
import { humanizeDateTime } from "../Utils";

type HumanizeDateTimeProps = {
    dateTime: Moment;
    includeAgo?: boolean;
};
export const HumanizeDateTime = (props: HumanizeDateTimeProps) => {
    const { t } = useTranslation();

    const getHumanized = () => {
        const humanized = humanizeDateTime(props.dateTime);
        if (humanized.startsWith("0")) {
            return t("Gui.Common.Labels.LessThanAMinute");
        }
        return humanized;
    };

    const includeAgo = props.includeAgo !== false;
    const [humanizedDate, setHumanizedDate] = useState(getHumanized());

    useEffect(() => {
        const interval = setInterval(() => {
            setHumanizedDate(getHumanized());
        }, 1000);
        return () => clearInterval(interval);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.dateTime]);

    return (
        <>
            {humanizedDate} {includeAgo && t("Gui.Common.Labels.Ago")}
        </>
    );
};
